import { render, staticRenderFns } from "./speed.vue?vue&type=template&id=078904cd&scoped=true&"
import script from "./speed.vue?vue&type=script&lang=js&"
export * from "./speed.vue?vue&type=script&lang=js&"
import style0 from "./speed.vue?vue&type=style&index=0&id=078904cd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078904cd",
  null
  
)

export default component.exports